// extracted by mini-css-extract-plugin
export default {"hoverable":"BusinessInfoSettings_hoverable__dFrYH"};